import Button from 'components/Basic/Button';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { autoEdgeDetectionThunk } from 'store/slices/RoofToolLinesSlice/autoEdgeDetectionThunk';
import { resetEdgeEdits } from 'store/slices/RoofToolLinesSlice';
import { useState } from 'react';

export default function AutoEdgeDetectionButton() {
	const dispatch = useDispatch<AppDispatch>();
	const { uuid } = useSelector((s: RootState) => s.roofData.data);
	const { loading: autoEdgeDetectionInProgress } = useSelector((s: RootState) => s.roofToolLines.autoEdgeDetection);
	const { createSpecialEdges, updateSpecialEdges, selectedFacets } = useSelector((s: RootState) => s.roofToolLines.data);

	// Check for reset popup:
	const needGutterLineUpdate = Object.keys(selectedFacets)
		.some(eachFacet => (selectedFacets[eachFacet].newAddedGutterLines.length > 0 ||
			selectedFacets[eachFacet].removedGutterLineIds.length > 0)
		);

	const hasUnsavedChnages =
		createSpecialEdges.length > 0 ||
		updateSpecialEdges.length > 0 ||
		needGutterLineUpdate;

	const [confirm, setConfirm] = useState<boolean>(false);

	function hanldeConfirmation() {
		setConfirm(false);
		dispatch(resetEdgeEdits());
		dispatchAutoEdgeDetectionThunk();
	}

	function dispatchAutoEdgeDetectionThunk() {
		dispatch(autoEdgeDetectionThunk({ uuid }));
	}

	function handleButtonClick() {
		if (hasUnsavedChnages) {
			setConfirm(true);
			return;
		}
		dispatchAutoEdgeDetectionThunk();
	}

	return (<>
		<Button
			className="auto-detection-btn auto-detection-btn-main"
			onClick={handleButtonClick}
			showLoader={autoEdgeDetectionInProgress}
		>
			Auto Detect
		</Button>

		<ConfirmationModal
			message='This action will override your unsaved changes. Are you sure you want to proceed?'
			open={confirm}
			onCancel={() => setConfirm(false)}
			onConfirm={hanldeConfirmation}
		/>
	</>);
}